import { render, staticRenderFns } from "./oeb-ejercicios.vue?vue&type=template&id=677489f6&scoped=true"
import script from "./oeb-ejercicios.vue?vue&type=script&lang=js"
export * from "./oeb-ejercicios.vue?vue&type=script&lang=js"
import style0 from "./oeb-ejercicios.vue?vue&type=style&index=0&id=677489f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677489f6",
  null
  
)

export default component.exports